// 获取有效的快捷查询数据
export default ({ quickItem, fieldsGroup, sortFields }) => {
    // 全部筛选字段
    const fullQueryFields = fieldsGroup.map(v => {
        return {
            groupKey: v.groupKey,
            groupTitle: v.groupTitle,
            fields: v?.fields?.map(v1 => {
                const fieldValue = quickItem?.fields?.[v1.name]

                if (!fieldValue?.displayValue) {
                    return {
                        name: v1.name,
                        value: undefined,
                        displayValue: ''
                    }
                }

                return {
                    name: v1.name,
                    value: fieldValue.value,
                    displayValue: fieldValue?.displayValue
                }
            })
        }
    })

    // 筛选出配置中存在且有值的，丢弃已失效的字段
    const validQueryFields = fullQueryFields
        .map(v => {
            return {
                ...v,
                fields: v?.fields?.filter(v => v?.displayValue)
            }
        })
        .filter(v => v.fields?.length)

    // 筛选出配置中存在且有值的，丢弃已失效的字段
    const validSortFields =
        quickItem?.sortFields &&
        sortFields?.find(v => v.name === quickItem?.sortFields?.name) &&
        quickItem?.sortFields?.displayValue &&
        quickItem?.sortFields

    return {
        validQueryFields,
        validSortFields,
        fullQueryFields
    }
}
